
$(document).ready(function () {
    function replaceUrlParam(url, paramName, paramValue)
    {
        if (paramValue == null) {
            paramValue = '';
        }
        var pattern = new RegExp('\\b('+paramName+'=).*?(&|#|$)');
        if (url.search(pattern)>=0) {
            return url.replace(pattern,'$1' + paramValue + '$2');
        }
        url = url.replace(/[?#]$/,'');
        return url + (url.indexOf('?')>0 ? '&' : '?') + paramName + '=' + paramValue;
    }
    // For catalog page
    const detectCheckedFormat = (el) => {
        if(el.find('.checkbox-col input:checked').length) {
            el.addClass('active');
            el.find('.cart-btn').removeAttr('disabled');

            let currentPrice = el.find('.price-number:not(.single-price) span'),
                currentOldPrice = el.find('.old-price span'),
                currentSalePrice = el.find('.price-subtitle .price-sale'),
                currentSale = el.find('.price-subtitle .sale-percent'),
                currentPriceNumber = 0,
                currentOldPriceNumber = 0;
                inCart = true;

            el.find('.checkbox-col input:checked').siblings('label').each(function() {
                if (! $(this).attr('data-cart')) {
                    inCart = false;
                }
                currentPriceNumber += parseFloat($(this).find('span:last-of-type').html().replace(/\s+/g, ''));
                currentOldPriceNumber += parseFloat($(this).find('span:last-of-type').attr('data-old-price'));
            });

            if(currentPriceNumber.toFixed(1).split('.')[1] == 0) {
                currentPrice.html(currentPriceNumber.toFixed(0));
            } else {
                currentPrice.html(currentPriceNumber.toFixed(1));
            }
            if(currentOldPriceNumber.toFixed(1).split('.')[1] == 0) {
                currentOldPrice.html(currentOldPriceNumber.toFixed(0));
            } else {
                currentOldPrice.html(currentOldPriceNumber.toFixed(1));
            }
            if((currentOldPriceNumber - currentPriceNumber).toFixed(1).split('.')[1] == 0) {
                currentSalePrice.html((currentOldPriceNumber - currentPriceNumber).toFixed(0));
            } else {
                currentSalePrice.html((currentOldPriceNumber - currentPriceNumber).toFixed(1));
            }
            currentSale.html(100 - (parseInt((currentPriceNumber*100)/currentOldPriceNumber)));
            if (inCart) {
                el.find('.cart-btn.js-cart-button').hide();
                el.find('.cart-btn.basket-link').show();
            } else {
                el.find('.cart-btn.basket-link').hide();
                el.find('.cart-btn.js-cart-button').show();
            }
        } else {
            el.find('.cart-btn.basket-link').hide();
            el.find('.cart-btn.js-cart-button').show();
            el.removeClass('active');          
            el.find('.cart-btn').attr('disabled', true);  
            var numbers = [];
            el.find('.checkbox-col .checkbox-group.js-format-price span').each(function() {
                if (parseFloat($(this).html()) > 0) {
                    numbers.push(parseFloat($(this).html().replace(/\s+/g, '')));
                }
            });
            if (numbers.length) {
                el.find('.single-price').show();
                el.find('.single-price span').html(Math.min(...numbers));
            } else {
                el.find('.single-price').hide();
                el.find('.single-price span').html('0');
            }
        }
    }

    function init()
    {
        $('.catalog-item').each(function() {
            detectCheckedFormat($(this));
        });

        $('.product-tile .checkbox-group input').each(function(){
            if($(this).is(':checked')) {
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').slideDown();
            } else {
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').find('input:checked').each(function() {
                    $(this).prop('checked', false);
                });
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').slideUp();
            }
            detectCheckedFormat($(this).closest('.product-tile'));
        });
    }

    init();

    $('.js-platform-content, .product-tile').on('change', '.checkbox-group input', function() {
        detectCheckedFormat($(this).closest('.catalog-item'));
        if($(this).closest('.product-tile').length) {
            detectCheckedFormat($(this).closest('.product-tile'));
            if($(this).is(':checked')) {
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').slideDown();
            } else {
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').find('input:checked').each(function() {
                    $(this).prop('checked', false);
                });
                $(this).closest('.checkbox-group').siblings('.checkbox-wrap').slideUp();
            }
        }
    });



    $('.js-platform-content, .wrap_content').on('click', '.click-for-show', function() {
        if (window.innerWidth >= 1200) {
            if($(this).hasClass('open')) {
                $('.click-for-show').each(function() {
                    $(this).removeClass('open');
                    $(this).next('.traffic-hidden-block').slideUp();
                });
            } else {
                $('.click-for-show').each(function() {
                    $(this).addClass('open');
                    $(this).next('.traffic-hidden-block').slideDown();
                });
            }
        } else {
            $(this).toggleClass('open');
            $(this).next('.traffic-hidden-block').slideToggle();
        }
    });

    //pagination
    // $('.js-platform-content').on('click', '.pagination li', function (e) {
    //     e.preventDefault();
    //     var url = $(this).attr('data-url');
    //     var title = $('head title').text();
    //     var req = $.ajax({
    //         method: 'get',
    //         url: url,
    //     });
    //     req.then(function(resp) {
    //         if (resp.success) {
    //             if (resp.html) {
    //                 $('.js-platform-content').html('');
    //                 $('.js-platform-content').html(resp.html);
    //                 if (resp.pager) {
    //                     $('.js-platform-content').append(resp.pager);
    //                 }
    //                 init();
    //             }
    //             history.pushState({}, title, url);
    //         }
    //     });
    // });
    $('.js-platform-content').on('click', '.pagination li', function (e) {
        $('.overlay_page').show();
        $('.loader_wrap').show();
    });
    
    //is best
    $('#bestOffers').on('click', function (e) {
        var isBest = $(this).prop('checked') ? 1 : '';
        var url = $(this).attr('data-action');
        url = replaceUrlParam(url, 'is_best', isBest);

        var title = $('head title').text();
        var req = $.ajax({
            method: 'get',
            url: url,
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-platform-content').html('');
                    $('.js-platform-content').html(resp.html);
                    if (resp.pager) {
                        $('.js-platform-content').append(resp.pager);
                    }
                    if (resp.filter_result_text) {
                        $('.filter-result-text p').text(resp.filter_result_text);
                    }
                    init();
                }
                history.pushState({}, title, url);
            }
        });
    });

    //show by
    $('.js-platform-content').on('click', '.js-show-by ul li', function (e) {
        var per_page = $(this).text();
        var url = $('.js-show-by').attr('data-action');
        url = replaceUrlParam(url, 'per_page', per_page);

        var title = $('head title').text();
        var req = $.ajax({
            method: 'get',
            url: url,
        });
        req.then(function(resp) {
            if (resp.success) {
                if (resp.html) {
                    $('.js-platform-content').html('');
                    $('.js-platform-content').html(resp.html);
                    if (resp.pager) {
                        $('.js-platform-content').append(resp.pager);
                    }
                    init();
                }
                history.pushState({}, title, url);
            }
        });
    });

    //mobile sort
    $('.js-filter-sort-select ul li').on('click', function () {
        var action = $(this).attr('data-action');
        if (action) {
            location.href = action;
        }
    });
    
})